module.exports = __webpack_public_path__ + "media/images/icon/cancel-d5c5b2a922b436fe6070aa9313c18966.svg";